import Cookies from 'js-cookie';
import {
  PIN,
  USER_ACCESS_COOKIE,
  SUPER_USER_ACCESS_COOKIE,
  USER_CHAT,
  USER_SESSION,
  FIDELIZE_BROKER_FEATURES_COOKIE,
  DYNATRACE_USER_TAG_COOKIE
} from '@plataforma/utils';
import { zenDesk } from '@services/gtm';

/**
 * clearAuthData()
 *
 * Clear the authentication data before redirecting user in a
 * logout process for regular or super users.
 *
 * @param {boolean} keepSuperUserData - a boolean to inform if the "suac" cookie shall be kept
 */
export const clearAuthData = async (keepSuperUserData = false) => {
  const userTheme = localStorage.getItem('userTheme');

  await zenDesk.close();
  localStorage.clear();

  userTheme && localStorage.setItem('userTheme', userTheme);

  Cookies.remove(PIN, { domain: `${process.env.REACT_APP_DOMAIN}` });
  Cookies.remove(USER_SESSION, { domain: `${process.env.REACT_APP_DOMAIN}` });
  Cookies.remove(USER_CHAT, { domain: `${process.env.REACT_APP_DOMAIN}` });
  Cookies.remove(USER_ACCESS_COOKIE, {
    domain: `${process.env.REACT_APP_DOMAIN}`
  });
  Cookies.remove(FIDELIZE_BROKER_FEATURES_COOKIE, {
    domain: `${process.env.REACT_APP_DOMAIN}`
  });
  Cookies.remove(DYNATRACE_USER_TAG_COOKIE, {
    domain: `${process.env.REACT_APP_DOMAIN}`
  });

  // if it's not supposed to keep the super user data, remove this item too
  !keepSuperUserData &&
    Cookies.remove(SUPER_USER_ACCESS_COOKIE, {
      domain: `${process.env.REACT_APP_DOMAIN}`
    });
};
